/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';

import { BasicType } from '../../interfaces/InterfacesLocal';
import { BasicNomenclator } from '../../interfaces/ServerInterfaces';
import { limpiarObjeto } from '../../utils/helpers';
import AsyncComboBox from '../forms/AsyncCombobox';
import ComboBox from '../forms/Combobox';
import DateInput from '../forms/DateInput';
import Input from '../forms/Input';
import MultiSelect from '../forms/Multiselect';
import Select from '../forms/Select';
import Toggle from '../forms/Toggle';
import Button from '../misc/Button';
import { FilterOpts, TableContext } from '../misc/GenericTable';
import MultipleFilterBtn from '../misc/MultipleFilterBtn';

interface FilterComponentInt {
  availableFilters: FilterOpts[]
  filterAction: Function
}

interface FilterComponentInterface {
  filterComponent: FilterComponentInt | undefined
  filterActived: boolean
  setFilterActived: React.Dispatch<React.SetStateAction<boolean>>
  closeModal: Function
}

const FilterComponent = ({
  filterComponent,
  filterActived,
  setFilterActived,
  closeModal,
}: FilterComponentInterface) => {
  const { selectedFilter, setSelectedFilter } = useContext(TableContext)

  const { handleSubmit, control, unregister, watch, reset } = useForm()
  const activeIndex = selectedFilter?.map((item) => item.id)
  const [selectedFilters, setSelectedFilters] = useState<BasicNomenclator[]>([])

  useEffect(() => {
    console.log(selectedFilter!)
    setSelectedFilters(
      selectedFilter!.map((item) => ({
        id: item.id.toString(),
        name: item.id.toString(),
      })) ?? []
    )
    const disabledFiltersCode = filterComponent?.availableFilters
      .filter((_, idx) => !activeIndex?.includes(idx))
      .map((item) => item.filterCode)
    if (selectedFilter?.length === 0 && filterActived) {
      filterComponent?.filterAction(null)
      setFilterActived(false)
    }
    unregister(disabledFiltersCode)
  }, [selectedFilter])

  const resetForm = () => {
    setSelectedFilter!([])

    filterComponent?.filterAction(null)

    closeModal()
  }

  const onSubmit: SubmitHandler<BasicType> = (data) => {
    const dataToSend = limpiarObjeto(data)

    const findFilterItem = (filterCode: string) => {
      return filterComponent?.availableFilters?.find((item) => {
        if (item.format === 'datepicker-range') {
          return item?.datepickerRange?.some(
            (newItem) => newItem?.filterCode === filterCode
          )
        }
        if (item.format === 'price-range') {
          return item?.priceRange?.some(
            (price) => price?.filterCode === filterCode
          )
        }
        return item.filterCode === filterCode
      })
    }

    const newSelectedFilter = Object.entries(dataToSend).map(([id, name]) => {
      const filterItem = findFilterItem(id)
      return {
        id,
        name,
        description: filterItem?.format ?? '',
        value: dataToSend[filterItem?.filterCode!],
      }
    })
    filterComponent?.filterAction(dataToSend)
    setSelectedFilter!(newSelectedFilter)
    closeModal()
    setFilterActived(true)
  }
  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="flex w-full flex-col gap-5"
    >
      {/**ACTIONS BUTTONS */}
      <div className="flex w-full items-center justify-center">
        <MultipleFilterBtn
          btnName="Criterios de búsqueda"
          selected={selectedFilters}
          data={
            filterComponent?.availableFilters.map((item) => ({
              id: item.filterCode,
              name: item.name,
            })) ?? []
          }
          setSelected={(data: BasicNomenclator[], unregistered?: string) => {
            setSelectedFilters(data)
            unregistered && unregister(unregistered)
          }}
          onClear={() => {
            if (selectedFilters.length > 0) {
              reset()
              setSelectedFilters(() => [])
            }
          }}
        />
      </div>

      {/**FILTERS BODY */}
      <div className="flex flex-1 flex-col gap-3 px-1">
        {filterComponent?.availableFilters
          ?.filter((item) =>
            selectedFilters.some((s) => s.id === item.filterCode)
          )
          .map((item, idx) =>
            item.format === 'select' && item.asyncData ? (
              <AsyncComboBox
                key={idx}
                name={item.filterCode}
                control={control}
                dataQuery={{
                  url: item.asyncData.url,
                  defaultParams: item.asyncData?.defaultParams,
                }}
                label={item.name}
                normalizeData={{
                  id: item.asyncData.idCode,
                  name: item.asyncData.dataCode,
                }}
                dependendValue={
                  item.dependentOn
                    ? { [item.dependentOn]: watch(item.dependentOn) }
                    : undefined
                }
                // defaultItem={selectedFilter?.find(elem => elem.id === item.filterCode)?.name ?? null}
              />
            ) : item.format === 'select' ? (
              <ComboBox
                key={idx}
                name={item.filterCode}
                control={control}
                data={item.data ?? []}
                label={item.name}
                defaultValue={
                  selectedFilter?.find((elem) => elem.id === item.filterCode)
                    ?.name ?? null
                }
                // rules={{ required: "Seleccione" }}
              />
            ) : item.format === 'multiselect' ? (
              <MultiSelect
                key={idx}
                name={item.filterCode}
                control={control}
                data={item.data ?? []}
                label={item.name}
                //@ts-ignore
                byDefault={
                  selectedFilter
                    ?.find((elem) => elem.id === item.filterCode)
                    ?.name.join(', ') ?? null
                }

                // rules={{ required: "Seleccione" }}
              />
            ) : item.format === 'input' ? (
              <Input
                key={idx}
                name={item.filterCode}
                control={control}
                label={item.name}
                defaultValue={
                  selectedFilter?.find((elem) => elem.id === item.filterCode)
                    ?.name ?? null
                }
              />
            ) : item.format === 'number' ? (
              <Input
                key={idx}
                name={item.filterCode}
                control={control}
                label={item.name}
                type={'number'}
                defaultValue={
                  selectedFilter?.find((elem) => elem.id === item.filterCode)
                    ?.name ?? null
                }
              />
            ) : item.format === 'boolean' ? (
              <Toggle
                key={idx}
                name={item.filterCode}
                control={control}
                title={item.name}
                defaultValue={
                  selectedFilter?.find((elem) => elem.id === item.filterCode)
                    ?.name ?? null
                }
              />
            ) : item.format === 'datepicker-range' ? (
              <div
                key={idx}
                className="flex w-full flex-col items-start justify-start"
              >
                <h2 className="mb-1 inline-flex items-center text-sm font-medium text-gray-700 first-letter:uppercase">
                  {item.name}
                </h2>
                <div
                  key={idx}
                  className="flex w-full items-center gap-1 font-normal"
                >
                  {item.datepickerRange?.map((rangeDatePicker, index) => {
                    return (
                      <div className={'w-full'}>
                        <DateInput
                          key={index}
                          name={rangeDatePicker.filterCode}
                          label={rangeDatePicker.name}
                          control={control}
                          // rules={{ required: "Este campo es requerido" }}
                          untilToday={rangeDatePicker.isUnitlToday}
                          includeTime={rangeDatePicker.includingTime}
                          fromCustom={
                            selectedFilter?.find(
                              (elem) => elem.id === item.filterCode
                            )?.name ?? null
                          }
                          defaultValue={
                            selectedFilter?.find(
                              (elem) => elem.id === rangeDatePicker.filterCode
                            )?.name ?? null
                          }
                          widthFull={true}
                        />
                      </div>
                    )
                  })}
                </div>
              </div>
            ) : item.format === 'price-range' ? (
              <div
                key={idx}
                className="flex w-full flex-col items-start justify-start"
              >
                <h2 className="mb-1 inline-flex items-center text-sm font-medium text-gray-700 first-letter:uppercase">
                  {item.name}
                </h2>

                <div key={idx} className="flex items-center gap-1 font-normal">
                  {item.priceRange?.map((priceRange, index) => {
                    return index !== 2 ? (
                      <Input
                        key={index}
                        name={priceRange.filterCode}
                        control={control}
                        type="number"
                        label={priceRange.name}
                        // rules={{ required: "Este campo es requerido" }}
                        textAsNumber
                      />
                    ) : (
                      <Select
                        key={index}
                        name={priceRange.filterCode}
                        label={priceRange.name}
                        control={control}
                        data={
                          priceRange?.currencies?.map((item) => ({
                            id: item,
                            name: item,
                          })) ?? []
                        }
                        // rules={{ required: "Este campo es requerido" }}
                      />
                    )
                  })}
                </div>
              </div>
            ) : (
              item.format === 'datepicker' && (
                <div key={idx} className="flex items-center gap-1 font-normal">
                  <DateInput
                    name={item.filterCode}
                    label={item.name}
                    control={control}
                    fromCustom={
                      selectedFilter?.find(
                        (elem) => elem.id === item.filterCode
                      )?.name ?? null
                    }
                    // rules={{ required: "Este campo es requerido" }}
                    untilToday={item?.isUntilToday}
                    defaultValue={
                      selectedFilter?.find(
                        (elem) => elem.id === item.filterCode
                      )?.name ?? null
                    }
                  />
                </div>
              )
            )
          )}
      </div>
      <div className={'flex w-full justify-end gap-5'}>
        <Button
          name="Limpiar"
          textColor="customBlue"
          outline
          action={resetForm}
        />
        <Button name="Aplicar" type="submit" />
      </div>
    </form>
  )
}

export default FilterComponent
